import { jsx as o, jsxs as c, Fragment as _ } from "react/jsx-runtime";
import { forwardRef as ve, Fragment as ot, createContext as rt, useContext as nt, useState as j, useEffect as de, useCallback as R, useRef as fe, useMemo as le, memo as we } from "react";
import { useTheme as re, useMediaQuery as $e, Stack as P, Box as u, styled as F, Paper as N, MenuItem as it, ListItemText as Le, ListItemIcon as Te, Divider as ye, Popper as ne, ClickAwayListener as ce, List as at, ListItemButton as lt, Fade as He, TableCell as st, TableBody as dt, TableRow as ct, createFilterOptions as pt, MenuList as gt } from "@mui/material";
import { faMagnifyingGlass as ut } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import { styled as O } from "@mui/material/styles";
import "@mui/material/CssBaseline";
import { d as S, T as B, c as T, e as te, f as M, g as se, b as A, h as be } from "./custom-types-BLq_qmUY.js";
import { b as Q, a as ue } from "./shadows-DovTEXlb.js";
import { r as y } from "./roundings-rAN_HXvA.js";
import { s as n } from "./spacings-C27fg6SF.js";
import { faCircleQuestion as mt, faXmark as Oe, faExclamationCircle as ht } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as xt } from "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import L from "@mui/material/Box";
import ft from "@mui/material/Dialog";
import yt from "@mui/material/DialogTitle";
import bt from "@mui/material/DialogContent";
import Ct from "@mui/material/DialogActions";
import vt from "@mui/material/Checkbox";
import { faSquareCheck as wt, faSquareMinus as Ft, faCircleDot as kt, faSlashForward as It, faPlus as St, faAngleRight as zt } from "@fortawesome/pro-solid-svg-icons";
import { faSquare as At, faSquareCheck as Bt, faSquareMinus as Et, faCircle as Dt, faCircleDot as Wt } from "@fortawesome/pro-light-svg-icons";
import Pt from "@mui/material/Stack";
import Rt from "@mui/material/Link";
import "@mui/material/Typography";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import Mt from "@mui/material/Button";
import "@mui/material/useAutocomplete";
import "@emotion/cache";
import "@emotion/react";
import me from "@mui/material/Chip";
import { faCircle as $t } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { faXmark as Ve } from "@fortawesome/pro-regular-svg-icons/faXmark";
import Lt from "@mui/material/Breadcrumbs";
import { faSlashForward as Tt } from "@fortawesome/pro-solid-svg-icons/faSlashForward";
import { faChevronRight as Ht } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { T as E } from "./Typography-HkIo7ajX.js";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import Ot from "@mui/material/IconButton";
import { T as Z } from "./Tooltip-NnEn6UuH.js";
import { C as _e } from "./CircularProgress-TGiQxfpH.js";
import "@mui/material/ButtonGroup";
import { S as Vt } from "./ShadowBox-BeNZgJg1.js";
import "@mui/material/Switch";
import _t from "@mui/material/Radio";
import jt from "@mui/material/FormControl";
import je from "@mui/material/FormLabel";
import Be from "@mui/material/InputAdornment";
import Nt from "@mui/material/OutlinedInput";
import Ut from "@mui/material/FormHelperText";
import "@mui/material/TextField";
import "@mui/material/Autocomplete";
import { faCheck as qt } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faCircleQuestion as Fe } from "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import { Rnd as Xt } from "react-rnd";
import { HexAlphaColorPicker as Gt, HexColorInput as Qt } from "react-colorful";
import { useDebounce as Zt, useToggle as Yt } from "@uidotdev/usehooks";
import { useClickAway as Jt, useUnmount as Kt } from "react-use";
import "react-hotkeys-hook";
import "@react-spring/web";
import { a as eo, T as to } from "./TypeWriter-BgzZBTxS.js";
import { T as oo } from "./TextFormatter-BVdWjwiB.js";
import "./AutoScrollContainer-CzyjIY1o.js";
import { flexRender as ro } from "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import { isValidColor as no, validateBounds as io } from "./components/color-picker/utils/index.js";
import { faCircleExclamation as ao } from "@fortawesome/pro-regular-svg-icons/faCircleExclamation";
const Ne = {
  common: {
    white: "#FFFFFF",
    black: "#000000"
  },
  tonalOffset: 0,
  text: {
    primary: "#000000",
    secondary: "rgba(0, 0, 0, 0.54)",
    // not defined yet
    disabled: "rgba(0, 0, 0, 0.38)"
    // not defined yet
  },
  [S.grey]: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F2F4F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#182230",
    900: "#101828",
    950: "#0C111D",
    main: "#667085",
    dark: "",
    light: "",
    contrastText: "#344054"
  },
  [S.primary]: {
    25: "#F5FAFF",
    50: "#EFF8FF",
    100: "#D1E9FF",
    200: "#B2DDFF",
    300: "#84CAFF",
    400: "#53B1FD",
    500: "#2E90FA",
    600: "#1570EF",
    700: "#175CD3",
    800: "#1849A9",
    900: "#194185",
    950: "#102A56",
    main: "#2E90FA",
    dark: "",
    light: "",
    contrastText: "#175CD3"
  },
  [S.error]: {
    25: "#FFFBFA",
    50: "#FEF3F2",
    100: "#FEE4E2",
    200: "#FECDCA",
    300: "#FDA29B",
    400: "#F97066",
    500: "#F04438",
    600: "#D92D20",
    700: "#B42318",
    800: "#912018",
    900: "#7A271A",
    950: "#55160C",
    main: "#F04438",
    dark: "",
    light: "",
    contrastText: "#B42318"
  },
  [S.warning]: {
    25: "#FFFCF5",
    50: "#FFFAEB",
    100: "#FEF0C7",
    200: "#FEDF89",
    300: "#FEC84B",
    400: "#FDB022",
    500: "#F79009",
    600: "#DC6803",
    700: "#B54708",
    800: "#93370D",
    900: "#7A2E0E",
    950: "#4E1D09",
    main: "#F79009",
    dark: "",
    light: "",
    contrastText: "#B54708"
  },
  [S.success]: {
    25: "#F6FEF9",
    50: "#ECFDF3",
    100: "#DCFAE6",
    200: "#ABEFC6",
    300: "#75E0A7",
    400: "#47CD89",
    500: "#17B26A",
    600: "#079455",
    700: "#067647",
    800: "#085D3A",
    900: "#074D31",
    950: "#053321",
    main: "#17B26A",
    dark: "",
    light: "",
    contrastText: "#067647"
  },
  // additional colors
  [S.indigo]: {
    25: "#F5F8FF",
    50: "#EEF4FF",
    100: "#E0EAFF",
    200: "#C7D7FE",
    300: "#A4BCFD",
    400: "#8098F9",
    500: "#6172F3",
    600: "#444CE7",
    700: "#3538CD",
    800: "#2D31A6",
    900: "#2D3282",
    950: "#1F235B",
    main: "#6172F3",
    dark: "",
    light: "",
    contrastText: "#3538CD"
  },
  [S.purple]: {
    25: "#FAFAFF",
    50: "#F4F3FF",
    100: "#EBE9FE",
    200: "#D9D6FE",
    300: "#BDB4FE",
    400: "#9B8AFB",
    500: "#7A5AF8",
    600: "#6938EF",
    700: "#5925DC",
    800: "#4A1FB8",
    900: "#3E1C96",
    950: "#27115F",
    main: "#7A5AF8",
    dark: "",
    light: "",
    contrastText: "#5925DC"
  },
  [S.pink]: {
    25: "#FEF6FB",
    50: "#FDF2FA",
    100: "#FCE7F6",
    200: "#FCCEEE",
    300: "#FAA7E0",
    400: "#F670C7",
    500: "#EE46BC",
    600: "#DD2590",
    700: "#C11574",
    800: "#9E165F",
    900: "#851651",
    950: "#4E0D30",
    main: "#EE46BC",
    dark: "",
    light: "",
    contrastText: "#C11574"
  },
  [S.rose]: {
    25: "#FFF5F6",
    50: "#FFF1F3",
    100: "#FFE4E8",
    200: "#FECDD6",
    300: "#FEA3B4",
    400: "#FD6F8E",
    500: "#F63D68",
    600: "#E31B54",
    700: "#C01048",
    800: "#A11043",
    900: "#89123E",
    950: "#510B24",
    main: "#F63D68",
    dark: "",
    light: "",
    contrastText: "#C01048"
  },
  action: {
    // Used to style components when they are in an active state, such as icons in active tabs or active buttons
    active: "#175CD3",
    // Applied when a user hovers over interactive elements like buttons, list items, and cards.
    hover: "#D1E9FF",
    // Used for components that are selected, such as selected items in a list or selected tabs.
    selected: "#1570EF",
    // Applied to components that are disabled, affecting their text and background color to indicate they are not interactive
    disabled: "#98A2B3",
    // Used when components receive focus, often for accessibility and indicating the element is ready for interaction
    focus: "#84CAFF"
  }
}, ni = {
  fontFamily: "Inter, sans-serif",
  fontSize: 16,
  // base font size
  fontWeightLight: B.regular,
  fontWeightRegular: B.regular,
  fontWeightMedium: B.medium,
  fontWeightSemibold: B.semibold,
  fontWeightBold: B.bold,
  h1: {
    // display xxl
    fontSize: "72px",
    fontWeight: B.bold,
    lineHeight: "90px"
  },
  h2: {
    // display xl
    fontSize: "60px",
    fontWeight: B.bold,
    lineHeight: "72px"
  },
  h3: {
    // display lg
    fontSize: "48px",
    fontWeight: B.bold,
    lineHeight: "60px"
  },
  h4: {
    // display md
    fontSize: "36px",
    fontWeight: B.bold,
    lineHeight: "44px"
  },
  h5: {
    // display sm
    fontSize: "30px",
    fontWeight: B.bold,
    lineHeight: "38px"
  },
  h6: {
    // display xs
    fontSize: "24px",
    fontWeight: B.semibold,
    lineHeight: "38px"
  },
  subtitle1: {
    // text xl
    fontSize: "20px",
    fontWeight: B.semibold,
    lineHeight: "30px"
  },
  subtitle2: {
    // text lg
    fontSize: "18px",
    fontWeight: B.medium,
    lineHeight: "28px"
  },
  body1: {
    // text md
    fontSize: "16px",
    fontWeight: B.regular,
    lineHeight: "24px"
  },
  body2: {
    // Text small
    fontSize: "14px",
    fontWeight: B.regular,
    lineHeight: "20px"
  },
  caption: {
    // Text xs
    fontSize: "12px",
    fontWeight: B.regular,
    lineHeight: "18px"
  },
  button: {
    // Text inside <Button>
    fontSize: "14px",
    fontWeight: B.regular,
    textTransform: "none"
  }
}, he = (e) => ({
  "& svg": {
    width: `${e}px`,
    height: `${e}px`
  }
}), ie = (e) => ({
  "& svg": {
    color: e
  }
}), G = (e) => ({
  "& svg": {
    color: e
  }
}), xe = {
  [T.xs]: 14,
  [T.small]: 16,
  [T.medium]: 20,
  [T.large]: 24,
  [T.xl]: 24,
  [T.xxl]: 24
}, ii = (e) => ({
  defaultProps: {
    size: T.medium,
    variant: "outlined",
    color: "primary",
    disableRipple: !0,
    disableFocusRipple: !0
  },
  variants: [
    {
      props: { size: T.xl },
      style: {
        // TODO: understand why this padding is not aligned to the DS spacings
        padding: "14px",
        ...he(xe.xl)
      }
    },
    {
      props: { size: T.xxl },
      style: {
        padding: e.spacing(n.xl),
        ...he(xe.xxl)
      }
    }
  ],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: t }) => {
      const r = xe[t.size ?? T.medium];
      return {
        transition: "background 0.2s linear, box-shadow 0.2s linear, border 0.2s linear, color 0.2s linear",
        borderRadius: t.isCircled ? e.rounding(y.full) : e.rounding(y.md),
        border: `1px solid ${e.palette.primary[300]}`,
        ...he(r),
        "&.Mui-disabled": {
          border: `1px solid ${e.palette.grey[200]}`,
          boxShadow: Q.xs,
          ...G(e.palette.grey[400])
        }
      };
    },
    /** Styles applied to the root element if `edge="start"`. */
    edgeStart: {},
    /** Styles applied to the root element if `edge="end"`. */
    edgeEnd: {},
    /** Styles applied to the root element if `color="inherit"`. */
    colorInherit: {},
    /** Styles applied to the root element if `color="primary"`. */
    colorPrimary: ({ ownerState: t }) => {
      switch (t.variant) {
        case te.contained:
          return {
            border: "1px solid transparent",
            ...G(e.palette.common.white),
            background: e.palette.primary[600],
            boxShadow: Q.xs,
            "&:hover": {
              background: e.palette.primary[700]
            },
            "&:active": {
              border: `1px solid ${e.palette.primary[600]}`,
              background: e.palette.primary[600],
              boxShadow: ue.primaryXs
            },
            "&.Mui-disabled": {
              background: e.palette.grey[100]
            }
          };
        case te.outlined:
          return {
            border: `1px solid ${e.palette.primary[300]}`,
            ...G(e.palette.primary[700]),
            background: e.palette.primary[50],
            boxShadow: Q.xs,
            "&:hover": {
              background: e.palette.primary[100]
            },
            "&:active": {
              border: `1px solid ${e.palette.primary[300]}`,
              background: e.palette.primary[50],
              boxShadow: ue.primaryXs
            },
            "&.Mui-disabled": {
              background: e.palette.common.white
            }
          };
        case te.text:
          return {
            border: "1px solid transparent",
            ...G(e.palette.primary[700]),
            background: "transparent",
            "&:hover": {
              background: e.palette.primary[50]
            },
            "&:active": {
              background: "transparent"
            }
          };
        default:
          return {};
      }
    },
    /** Styles applied to the root element if `color="secondary"`. */
    colorSecondary: ({ ownerState: t }) => {
      switch (t.variant) {
        case te.outlined:
          return {
            border: `1px solid ${e.palette.grey[300]}`,
            ...G(e.palette.grey[700]),
            background: e.palette.common.white,
            boxShadow: Q.xs,
            "&:hover": {
              background: e.palette.grey[50]
            },
            "&:active": {
              border: `1px solid ${e.palette.grey[300]}`,
              background: e.palette.common.white,
              boxShadow: ue.greyXs
            },
            "&.Mui-disabled": {
              background: e.palette.common.white
            }
          };
        case te.text:
          return {
            border: "1px solid transparent !important",
            ...G(e.palette.grey[600]),
            background: "transparent",
            "&:hover": {
              background: e.palette.grey[50],
              ...G(e.palette.primary[700])
            },
            "&:active": {
              background: "transparent"
            }
          };
        default:
          return {};
      }
    },
    /** Styles applied to the root element if `color="error"`. */
    colorError: {},
    /** Styles applied to the root element if `color="info"`. */
    colorInfo: {},
    /** Styles applied to the root element if `color="success"`. */
    colorSuccess: {},
    /** Styles applied to the root element if `color="warning"`. */
    colorWarning: {},
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: e.spacing(n.md)
    },
    /** Styles applied to the root element if `size="medium"`. */
    sizeMedium: {
      // TODO: understand why this padding is not aligned to the DS spacings
      padding: "10px"
    },
    /** Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      padding: e.spacing(n.lg)
    }
  }
}), H = M.medium, lo = {
  [M.small]: "0 8px",
  [H]: "0 10px",
  [M.large]: "0 12px"
}, so = {
  [M.small]: "5px",
  [H]: "6px",
  [M.large]: "8px"
}, Ee = {
  [M.small]: "2px",
  [H]: "3px",
  [M.large]: "5px"
}, co = {
  [M.small]: "22px",
  [H]: "24px",
  [M.large]: "28px"
}, po = {
  [M.small]: "5px",
  [H]: "8px",
  [M.large]: "10px"
}, go = (e, t) => ({
  borderColor: e.palette.grey[300],
  background: e.palette.common.white,
  color: e.palette.grey[700],
  "& svg": {
    color: `${t[500]} !important`
  }
}), uo = (e) => ({
  border: `1px solid ${e[200]}`,
  background: e[50],
  color: e[700],
  "& svg": {
    color: `${e[500]} !important`
  },
  "&:hover": {
    background: e[100]
  }
}), mo = (e) => Object.values(S).map((t) => ({
  props: { color: t, variant: "outlined" },
  style: go(e, e.palette[t])
})), ho = (e) => Object.values(S).map((t) => ({
  props: { color: t, variant: "filled" },
  style: uo(e.palette[t])
})), ai = (e) => ({
  defaultProps: {
    variant: "filled",
    size: H,
    color: S.grey,
    // @ts-expect-error: it is possible to disable ripple but this prop is not presented in types
    disableRipple: !0
  },
  variants: [
    {
      props: { size: M.large },
      style: {
        height: "28px",
        fontSize: 14
      }
    },
    ...ho(e),
    ...mo(e)
  ],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: t }) => {
      const r = t.isIconOnly ? co[t.size ?? H] : "auto";
      return {
        width: r,
        height: r,
        fontWeight: e.typography.fontWeightMedium
      };
    },
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      fontSize: 12,
      height: "22px"
    },
    /** Styles applied to the root element if `size="medium"`. */
    sizeMedium: {
      fontSize: 14,
      height: "24px"
    },
    /** Styles applied to the root element if `color="error"`. */
    colorError: {},
    /** Styles applied to the root element if `color="info"`. */
    colorInfo: {},
    /** Styles applied to the root element if `color="primary"`. */
    colorPrimary: {},
    /** Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {},
    /** Styles applied to the root element if `color="success"`. */
    colorSuccess: {},
    /** Styles applied to the root element if `color="warning"`. */
    colorWarning: {},
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {},
    /** Styles applied to the avatar element. */
    avatar: ({ ownerState: t }) => ({
      borderRadius: e.rounding(y.full),
      overflow: "hidden",
      width: "12px",
      height: "12px",
      marginLeft: t.isIconOnly ? n.none : Ee[t.size ?? H]
    }),
    /** Styles applied to the icon element. */
    icon: ({ ownerState: t }) => {
      const r = t.isDotLeading ? po : Ee, i = t.isIconOnly ? n.none : r[t.size ?? H], a = t.isDotLeading ? "8px" : "12px";
      return {
        borderRadius: e.rounding(y.full),
        overflow: "hidden",
        width: a,
        height: a,
        marginLeft: i,
        ...t.isIconOnly && { marginRight: `${n.none} !important` }
      };
    },
    /** Styles applied to the label `span` element. */
    label: ({ ownerState: t }) => {
      const r = t.isIconOnly ? so : lo;
      return {
        padding: t.isIconOnly ? n.none : r[t.size ?? H],
        lineHeight: 1.5
      };
    },
    /** State class applied to the delete icon */
    deleteIcon: ({ ownerState: t }) => {
      const r = t.color ?? S.grey, i = e.palette[r], a = !!t["data-isCustomEndIcon"], l = i && "main" in i && a ? i.main : i[900];
      return {
        width: "14px",
        height: "14px",
        color: l,
        ...!a && { color: `${l} !important` },
        "&:hover": {
          color: `${l} !important`
        },
        ...a && { cursor: "default" }
      };
    },
    /** State class applied to the root element if keyboard focused. */
    focusVisible: {}
  }
}), x = ({ icon: e, ...t }) => /* @__PURE__ */ o(
  xt,
  {
    icon: e,
    ...t
  }
), xo = O(Ot, {
  shouldForwardProp: (e) => e !== "isCircled" && e !== "disableBackground" && e !== "hasPadding"
})(
  ({ theme: e, isCircled: t, disableBackground: r, hasPadding: i = !0 }) => ({
    ...t && {
      borderRadius: e.rounding(y.full)
    },
    ...r && {
      background: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "none !important"
      },
      "&:focus": {
        outline: "none !important",
        boxShadow: "none !important"
      },
      "&:active": {
        background: "none !important"
      }
    },
    ...!i && {
      padding: 0
    }
  })
), pe = ({
  children: e,
  label: t,
  isCircled: r = !1,
  disableBackground: i = !1,
  ...a
}) => /* @__PURE__ */ o(
  xo,
  {
    ...a,
    "aria-label": t,
    isCircled: r,
    disableBackground: i,
    children: e
  }
), ke = ({ onClose: e }) => /* @__PURE__ */ o(
  pe,
  {
    label: "Close",
    onClick: e,
    variant: "text",
    color: "secondary",
    size: "small",
    children: /* @__PURE__ */ o(
      x,
      {
        icon: Ve,
        size: "xs"
      }
    )
  }
), fo = ({
  title: e,
  description: t = void 0,
  direction: r,
  hasBottomPadding: i = !1,
  hasDivider: a = !1,
  iconProps: l,
  onClose: s = void 0
}) => {
  const d = re(), g = $e(d.breakpoints.down("sm")), p = r === "horizontal", b = r === "centered", k = r === "vertical", w = p ? "row" : "column", I = !!t, f = !!s, z = g ? n.md : n.xl, W = l.variant !== void 0, h = g ? n.xl : n["3xl"], C = 56;
  return /* @__PURE__ */ c(_, { children: [
    /* @__PURE__ */ o(
      P,
      {
        sx: {
          position: "absolute",
          inset: 0,
          p: h,
          ...b && {
            left: "50%",
            transform: `translateX(-${C / 2}px)`,
            px: 0
          }
        },
        children: !!W && /* @__PURE__ */ o(
          Co,
          {
            ...l,
            variant: l.variant ?? "primary",
            hasOuterCircles: l.hasOuterCircles ?? !1
          }
        )
      }
    ),
    /* @__PURE__ */ c(
      P,
      {
        sx: {
          position: "relative",
          ...a && { borderBottom: "1px solid", borderColor: "grey.200" }
        },
        children: [
          !!f && /* @__PURE__ */ o(
            u,
            {
              position: "absolute",
              zIndex: 10,
              sx: { top: d.spacing(z), right: d.spacing(z) },
              children: /* @__PURE__ */ o(ke, { onClose: s })
            }
          ),
          /* @__PURE__ */ c(
            P,
            {
              direction: w,
              spacing: n.xl,
              sx: {
                p: h,
                pb: i ? n["2xl"] : 0,
                alignItems: k || I && p ? "start" : "center"
              },
              children: [
                /* @__PURE__ */ c(P, { children: [
                  !!W && /* @__PURE__ */ o(
                    u,
                    {
                      height: C,
                      width: C
                    }
                  ),
                  !W && !!l.icon && /* @__PURE__ */ o(P, { sx: { height: 47, justifyContent: "center" }, children: /* @__PURE__ */ o(
                    x,
                    {
                      icon: l.icon,
                      size: "xl"
                    }
                  ) })
                ] }),
                /* @__PURE__ */ c(
                  P,
                  {
                    direction: "column",
                    spacing: n.xs,
                    sx: {
                      ...b && {
                        alignItems: "center"
                      },
                      position: "relative",
                      zIndex: 1
                    },
                    children: [
                      /* @__PURE__ */ o(
                        Y.Header,
                        {
                          component: "div",
                          sx: { p: 0 },
                          children: /* @__PURE__ */ o(
                            E,
                            {
                              variant: "text",
                              size: "lg",
                              fontWeight: "semibold",
                              children: e
                            }
                          )
                        }
                      ),
                      !!t && /* @__PURE__ */ o(
                        E,
                        {
                          variant: "text",
                          size: "sm",
                          color: "grey.600",
                          children: t
                        }
                      )
                    ]
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}, yo = ({
  children: e,
  isRightAligned: t = !1,
  hasDivider: r = !1,
  checkboxProps: i = void 0,
  isFullWidth: a = !1
}) => {
  const l = re(), s = $e(l.breakpoints.down("sm")), d = !!i, g = t || d, p = s ? n.xl : n["3xl"];
  return /* @__PURE__ */ c(
    P,
    {
      direction: s ? "column-reverse" : "row",
      sx: {
        width: a ? "100%" : "auto",
        justifyContent: g ? "end" : "space-between",
        alignItems: s ? "start" : "center",
        ...(!g || s) && {
          "& > *": {
            width: s ? "100%" : "50%"
          }
        },
        ...r && {
          borderTop: "1px solid",
          borderColor: "grey.200"
        },
        px: p,
        pb: p,
        pt: r ? n["3xl"] : n["4xl"]
      },
      spacing: n.lg,
      children: [
        !!d && /* @__PURE__ */ o(
          u,
          {
            sx: {
              flex: "1 0 35%",
              width: "auto",
              "&&": {
                ml: s ? 0 : 8.75
              }
            },
            children: /* @__PURE__ */ o(
              qe,
              {
                size: "small",
                checked: i.checked,
                onChange: i.onChange,
                label: i.label
              }
            )
          }
        ),
        e
      ]
    }
  );
}, Y = ({
  children: e,
  isOpen: t,
  isClosableOnClickOutside: r = !0,
  size: i = "sm",
  onClose: a,
  onKeyDown: l = () => {
  },
  onKeyUp: s = () => {
  },
  useDefaultCloseButton: d = !0,
  closeButtonCustomPosition: g = { top: 16, right: 16 }
}) => /* @__PURE__ */ c(
  ft,
  {
    open: t,
    onKeyDown: l,
    onKeyUp: s,
    onClose: (p, b) => {
      b === "backdropClick" && !r || a();
    },
    scroll: "paper",
    maxWidth: i,
    fullWidth: !0,
    children: [
      !!d && /* @__PURE__ */ o(
        L,
        {
          position: "absolute",
          zIndex: 10,
          ...g,
          children: /* @__PURE__ */ o(ke, { onClose: a })
        }
      ),
      e
    ]
  }
);
Y.CloseButton = ke;
Y.Header = yt;
Y.HeaderWithIcon = fo;
Y.Body = bt;
Y.Footer = Ct;
Y.Actions = yo;
const Ue = ({
  label: e = "",
  description: t = "",
  size: r = "medium",
  disabled: i = !1,
  disabledReason: a = "",
  isReversed: l = !1,
  children: s,
  docLink: d = ""
}) => /* @__PURE__ */ c(
  Pt,
  {
    direction: l ? "row-reverse" : "row",
    alignItems: t ? "flex-start" : "center",
    ...!!e && { spacing: r === "small" ? n.md : n.lg },
    children: [
      /* @__PURE__ */ o(
        Z,
        {
          text: i && a ? a : "",
          placement: "bottom",
          shouldHighlightChildIcon: !1,
          children: s
        }
      ),
      !!e && /* @__PURE__ */ c(L, { ...!!l && { textAlign: "right" }, children: [
        /* @__PURE__ */ o(
          E,
          {
            variant: "text",
            size: r === "small" ? "sm" : "md",
            fontWeight: "medium",
            color: "grey.700",
            children: e
          }
        ),
        !!t && /* @__PURE__ */ c(
          E,
          {
            variant: "text",
            size: r === "small" ? "sm" : "md",
            fontWeight: "regular",
            color: "grey.600",
            children: [
              t,
              !!d && /* @__PURE__ */ c(_, { children: [
                " ",
                /* @__PURE__ */ o(
                  Rt,
                  {
                    rel: "noopener noreferrer",
                    target: "_blank",
                    color: "grey.700",
                    href: d,
                    "aria-label": "Documentation link",
                    children: /* @__PURE__ */ o(x, { icon: mt })
                  }
                )
              ] })
            ]
          }
        )
      ] })
    ]
  }
), qe = ({
  size: e = "medium",
  disabled: t = !1,
  disabledReason: r = "",
  label: i = "",
  description: a = "",
  isReversed: l = !1,
  docLink: s,
  ariaLabel: d = void 0,
  ...g
}) => /* @__PURE__ */ o(
  Ue,
  {
    label: i,
    description: a,
    size: e,
    isReversed: l,
    disabled: t,
    disabledReason: r,
    docLink: s,
    children: /* @__PURE__ */ o(
      vt,
      {
        size: e,
        disabled: t,
        icon: /* @__PURE__ */ o(x, { icon: At }),
        checkedIcon: /* @__PURE__ */ o(x, { icon: t ? Bt : wt }),
        indeterminateIcon: /* @__PURE__ */ o(x, { icon: t ? Et : Ft }),
        inputProps: {
          ...!!i && { "aria-label": i },
          ...!!d && { "aria-label": d }
        },
        ...g
      }
    )
  }
), bo = ({
  children: e,
  startIcon: t,
  hasPadding: r = !0,
  isLoading: i = !1,
  ...a
}) => {
  const l = { ...a };
  return a.color === "red" && (l.color = "error"), // @ts-expect-error: renaming for mui error color
  /* @__PURE__ */ o(
    Mt,
    {
      ...l,
      startIcon: (
        // eslint-disable-next-line react/jsx-no-leaked-render
        i ? /* @__PURE__ */ o(
          _e,
          {
            size: 20,
            label: "Action in progress"
          }
        ) : t
      ),
      sx: {
        ...r ? {} : { padding: 0 }
      },
      children: e
    }
  );
}, oe = ({ children: e, label: t = "", ...r }) => /* @__PURE__ */ o(
  bo,
  {
    ...r,
    ...!!t && { "aria-label": t },
    children: e
  }
), Co = ({
  variant: e,
  icon: t = void 0,
  hasOuterCircles: r = !0,
  hasAdditionalBackgroundLayer: i = !0
}) => {
  const a = re(), l = a.palette.grey[200];
  return /* @__PURE__ */ c(_, { children: [
    !!r && /* @__PURE__ */ o(
      L,
      {
        sx: {
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          overflow: "hidden"
        },
        children: /* @__PURE__ */ c(
          "svg",
          {
            height: "100%",
            style: {
              maxWidth: "100%",
              maxHeight: "100%"
            },
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ o(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "48",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.9"
                }
              ),
              /* @__PURE__ */ o(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "72",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.7"
                }
              ),
              /* @__PURE__ */ o(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "96",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.5"
                }
              ),
              /* @__PURE__ */ o(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "120",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.3"
                }
              ),
              /* @__PURE__ */ o(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "144",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.2"
                }
              ),
              /* @__PURE__ */ o(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "168",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.1"
                }
              )
            ]
          }
        )
      }
    ),
    !!t && /* @__PURE__ */ o(
      L,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "56px",
          height: "56px",
          padding: n.lg,
          borderRadius: y.full,
          border: i ? `8px solid ${a.palette[e][50]}` : void 0,
          background: a.palette[e][100]
        },
        children: /* @__PURE__ */ o(L, { color: `${e}.600`, children: /* @__PURE__ */ o(x, { icon: t }) })
      }
    )
  ] });
}, vo = {
  [se.button]: n.md,
  [se.text]: n.lg
}, wo = (e) => e === se.text, Xe = (e) => e ? vo[e] : n.none, li = (e) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      "& button": {
        backgroundColor: "transparent !important",
        "&:active": {
          backgroundColor: "transparent !important"
        },
        "&:focused": {
          backgroundColor: "transparent !important"
        },
        padding: n.none,
        margin: n.none,
        "& svg": {
          color: e.palette.grey[600],
          width: 20
        }
      }
    },
    /** Styles applied to the ol element. */
    ol: {},
    /** Styles applied to the li element. */
    li: ({ ownerState: t }) => {
      const r = wo(t.variant) ? e.palette.primary[700] : e.palette.grey[700], i = t.children ?? [], a = Array.isArray(i) ? i.length === 1 : !1, l = e.palette.grey[600];
      return {
        fontSize: 14,
        lineHeight: "20px",
        // if selector by tag is not enough, add data-attr to the element
        "& a": {
          display: "flex",
          alignItems: "center",
          "& svg": {
            width: 16,
            height: 16,
            color: e.palette.grey[500]
          },
          fontWeight: e.typography.fontWeightMedium,
          color: `${l} !important`,
          textDecoration: "none",
          "&:hover": {
            color: l
          }
        },
        "& p": {
          display: "flex",
          alignItems: "center",
          padding: e.spacing(n.xs, n.md),
          background: a ? "none" : e.palette.grey[50],
          borderRadius: e.rounding(y.sm),
          color: a ? l : r,
          "& svg": {
            width: 16,
            height: 16,
            color: a ? l : e.palette.primary[500]
          },
          fontWeight: e.typography.fontWeightSemibold
        }
      };
    },
    /** Styles applied to the separator element. */
    separator: ({ ownerState: t }) => ({
      color: e.palette.grey[300],
      margin: e.spacing(n.none, Xe(t.variant)),
      "& svg": {
        width: 8,
        height: 16,
        padding: e.spacing(n.none, n.sm)
      }
    })
  }
}), Fo = {
  [A.xs]: n["3xl"],
  [A.small]: n["4xl"],
  [A.medium]: n["5xl"],
  [A.large]: n["6xl"],
  [A.xl]: 7,
  [A.xxl]: n["7xl"]
}, ko = {
  [A.xs]: n.lg,
  [A.small]: "14px",
  [A.medium]: n.xl,
  [A.large]: "18px",
  [A.xl]: n["2xl"],
  [A.xxl]: n["3xl"]
}, Io = {
  [A.xs]: "12px",
  [A.small]: "14px",
  [A.medium]: "16px",
  [A.large]: "20px",
  [A.xl]: "22px",
  [A.xxl]: "22px"
}, So = A.medium, si = (e) => ({
  defaultProps: {
    sizes: So
  },
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: t }) => {
      const r = t.sizes, i = e.spacing(Fo[r]);
      return {
        overflow: "visible",
        position: "relative",
        background: e.palette.grey[100],
        width: i,
        height: i,
        zIndex: 1,
        "&:before": {
          content: "''",
          width: "100%",
          borderRadius: e.rounding(y.full),
          position: "absolute",
          inset: 0,
          border: "1px solid",
          borderColor: "rgba(0, 0, 0, 0.08)",
          height: "100%",
          zIndex: 2
        },
        "& img": {
          position: "relative",
          width: i,
          height: i,
          borderRadius: e.rounding(y.full),
          overflow: "hidden"
        }
      };
    },
    /** Styles applied to the root element if not `src` or `srcSet`. */
    colorDefault: {},
    /** Styles applied to the root element if `variant="circular"`. */
    circular: ({ ownerState: t }) => {
      const r = t.sizes, i = e.spacing(ko[r]), a = Io[r];
      return {
        "&:after": {
          content: "''",
          position: "absolute",
          top: 0,
          left: 0,
          width: "calc(100% + 4px)",
          height: "calc(100% + 4px)",
          transform: "translate(-2px, -2px)",
          borderRadius: e.rounding(y.full),
          border: "2px solid",
          borderColor: e.palette.common.white,
          transition: "all 0.2s linear"
        },
        "&:focus-visible": {
          outline: "none !important",
          "&:after": {
            width: "calc(100% + 8px)",
            height: "calc(100% + 8px)",
            transform: "translate(-4px, -4px)",
            border: "4px solid",
            borderColor: e.palette.grey[100]
          }
        },
        "& p, text": {
          fontWeight: e.typography.fontWeightMedium,
          fontSize: i,
          textTransform: "uppercase",
          color: e.palette.grey[600]
        },
        "& > svg": {
          color: e.palette.grey[950],
          width: a,
          height: a
        }
      };
    },
    /** Styles applied to the root element if `variant="rounded"`. */
    rounded: {},
    /** Styles applied to the root element if `variant="square"`. */
    square: {},
    /** Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {},
    /** Styles applied to the fallback icon */
    fallback: {}
  }
}), zo = ({ ...e }) => {
  const t = { ...e };
  return e.endIcon && (delete t.endIcon, t.deleteIcon = e.endIcon), t.isIconOnly ? /* @__PURE__ */ o(
    me,
    {
      variant: t.variant,
      color: t.color,
      size: t.size,
      icon: t.icon,
      isIconOnly: !0,
      onClick: t.onClick
    }
  ) : t.isDotLeading ? /* @__PURE__ */ o(
    me,
    {
      ...t,
      isDotLeading: !0,
      icon: /* @__PURE__ */ o(x, { icon: $t })
    }
  ) : /* @__PURE__ */ o(
    me,
    {
      ...t,
      deleteIcon: t.deleteIcon ?? /* @__PURE__ */ o(
        x,
        {
          icon: Ve,
          "data-testid": "DeleteIcon"
        }
      ),
      ...!t.onDelete && e.endIcon && {
        onDelete: () => {
        },
        deleteIcon: t.deleteIcon,
        "data-isCustomEndIcon": !0
      },
      ...!!t.href && { component: "a", clickable: !0 }
    }
  );
}, Ao = {
  [be.arrow]: /* @__PURE__ */ o(x, { icon: Ht }),
  [be.slash]: /* @__PURE__ */ o(x, { icon: Tt })
}, di = ({
  breadcrumbs: e,
  LinkComponent: t,
  maxItems: r = void 0,
  itemsBeforeCollapse: i = 2,
  itemsAfterCollapse: a = 1,
  variant: l = se.text,
  separator: s = be.arrow
}) => /* @__PURE__ */ o(
  Lt,
  {
    "aria-label": "breadcrumbs",
    variant: l,
    separator: Ao[s],
    maxItems: r,
    itemsBeforeCollapse: i,
    itemsAfterCollapse: a,
    children: e.map(({ label: d, icon: g, ...p }, b) => {
      const k = b === e.length - 1, w = /* @__PURE__ */ c(_, { children: [
        !!g && /* @__PURE__ */ o(
          L,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              ...!!d && { mr: Xe(l) }
            },
            children: /* @__PURE__ */ o(x, { icon: g })
          }
        ),
        d
      ] });
      return k ? /* @__PURE__ */ o(
        E,
        {
          variant: "text",
          size: "sm",
          children: w
        },
        b
      ) : /* @__PURE__ */ o(
        t,
        {
          ...p,
          children: w
        },
        b
      );
    })
  }
), Bo = F(pe, {
  shouldForwardProp: (e) => e !== "theme" && e !== "isActive"
})(({ theme: e, isActive: t }) => ({
  display: "flex",
  gap: e.spacing(n.xs),
  alignItems: "center",
  ...t ? {
    backgroundColor: e.palette.primary[50],
    transition: "background-color 0.2s ease",
    color: e.palette.primary[600],
    "&:hover": {
      backgroundColor: e.palette.primary[50],
      color: e.palette.primary[600],
      "& svg": {
        color: e.palette.primary[600]
      }
    },
    "& svg": {
      color: e.palette.primary[600]
    }
  } : {
    "&:hover:not(.Mui-disabled)": {
      backgroundColor: e.palette.grey[200],
      color: e.palette.grey[800],
      "& svg": {
        color: e.palette.grey[800]
      }
    },
    "&.Mui-disabled": {
      boxShadow: "none"
    }
  }
})), Eo = (e, t) => e ? "grey.400" : t ? "primary.600" : "grey.700", Do = ({ action: e, isActive: t, size: r = "small" }) => /* @__PURE__ */ o(
  Z,
  {
    title: e.tooltip ?? "",
    shouldHighlightChildIcon: !1,
    ...e.isDisabled ? e.disabledTooltip ?? {} : {},
    children: /* @__PURE__ */ o(u, { children: /* @__PURE__ */ c(
      Bo,
      {
        label: e.label,
        isActive: t,
        onClick: e.onClick,
        color: "secondary",
        variant: "text",
        size: r,
        disabled: e.isDisabled,
        children: [
          !!e.icon && /* @__PURE__ */ o(x, { icon: e.icon }),
          !!(!e.icon || e.shouldShowLabel) && /* @__PURE__ */ o(
            E,
            {
              variant: "text",
              size: "sm",
              fontWeight: "semibold",
              color: Eo(e.isDisabled, t),
              children: e.label
            }
          )
        ]
      }
    ) })
  }
), Ge = (e) => ({
  backgroundColor: e.palette.warning[50],
  border: `1px solid ${e.palette.warning[400]}`,
  color: e.palette.warning[600],
  "& svg": {
    color: e.palette.warning[400]
  },
  "&:hover": {
    backgroundColor: e.palette.warning[100],
    color: e.palette.warning[700],
    border: `1px solid ${e.palette.warning[400]}`,
    outline: "none"
  },
  "&.Mui-disabled": {
    backgroundColor: e.palette.warning[50],
    border: `1px solid ${e.palette.warning[400]}`,
    color: e.palette.warning[600],
    "& svg": {
      color: e.palette.warning[400]
    }
  }
}), ci = F(oe)(({ theme: e }) => Ge(e)), pi = F(pe)(({ theme: e }) => Ge(e)), Wo = F(Vt, {
  shouldForwardProp: (e) => e !== "theme"
})(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  gap: e.spacing(n.xs),
  padding: e.spacing(n.xs),
  borderRadius: e.rounding(y.md),
  border: `1px solid ${e.palette.grey[100]}`,
  backgroundColor: e.palette.common.white
})), gi = ({ actions: e, activeAction: t, size: r = "small" }) => /* @__PURE__ */ o(Wo, { shadowSize: "md", children: e.map((i) => /* @__PURE__ */ o(
  Do,
  {
    action: i,
    isActive: !!t && i.id === t,
    size: r
  },
  i.id
)) }), Po = ({
  size: e = "medium",
  disabled: t = !1,
  disabledReason: r = "",
  label: i = "",
  description: a = "",
  isReversed: l = !1,
  docLink: s,
  ...d
}) => {
  const g = t ? Wt : kt;
  return /* @__PURE__ */ o(
    Ue,
    {
      label: i,
      description: a,
      size: e,
      isReversed: l,
      disabled: t,
      disabledReason: r,
      docLink: s,
      children: /* @__PURE__ */ o(
        _t,
        {
          size: e,
          disabled: t,
          inputProps: { ...!!i && { "aria-label": i } },
          icon: /* @__PURE__ */ o(x, { icon: Dt }),
          checkedIcon: /* @__PURE__ */ o(x, { icon: g }),
          ...d
        }
      )
    }
  );
}, Ro = (e, t) => e ? /* @__PURE__ */ o(x, { icon: Fe }) : t ? /* @__PURE__ */ o(x, { icon: ao }) : null, Mo = ({
  errorText: e,
  warningText: t,
  isDisabled: r
}) => r ? "primary" : e ? "error" : t ? "warning" : "primary", Ie = ve(
  ({
    value: e = "",
    onChange: t,
    label: r = "",
    description: i = "",
    helperText: a = "",
    errorText: l = "",
    warningText: s = "",
    startIcon: d = null,
    charsLimit: g = void 0,
    isDisabled: p = !1,
    isMultiline: b = !1,
    inputProps: k = {},
    endAdornment: w = null,
    ...I
  }, f) => {
    const z = l || s || a, W = Mo({ errorText: l, warningText: s, isDisabled: p }), h = i ? Z : ot, C = !!l.trim() || void 0, m = !!s.trim() && !C || void 0, D = Ro(i, !!C || !!m), U = !I.rows && D;
    return /* @__PURE__ */ c(
      jt,
      {
        color: W,
        fullWidth: !0,
        children: [
          !!r && /* @__PURE__ */ o(je, { children: r }),
          /* @__PURE__ */ o(
            Nt,
            {
              ...I,
              value: e,
              onChange: (V) => {
                typeof t == "function" && (g && V.target.value.length > g || t(V));
              },
              disabled: p,
              multiline: b,
              inputRef: f,
              inputProps: k,
              startAdornment: !!d && /* @__PURE__ */ o(Be, { position: "start", children: d }),
              endAdornment: /* @__PURE__ */ c(_, { children: [
                !!w && w,
                !!U && /* @__PURE__ */ o(h, { title: !p && i || "", children: /* @__PURE__ */ o(Be, { position: "end", children: D }) })
              ] })
            }
          ),
          /* @__PURE__ */ c(L, { sx: { display: "flex", alignItems: "flex-start", justifyContent: "space-between" }, children: [
            !!z && /* @__PURE__ */ o(
              Ut,
              {
                error: !p && C,
                warning: !p && m,
                children: z
              }
            ),
            !!g && /* @__PURE__ */ o(
              L,
              {
                pl: n.md,
                ml: "auto",
                mt: n.sm,
                children: /* @__PURE__ */ o(
                  E,
                  {
                    variant: "text",
                    size: "sm",
                    color: "grey.600",
                    children: `${typeof e == "string" && (e.length.toLocaleString() || 0)}/${g.toLocaleString()}`
                  }
                )
              }
            )
          ] })
        ]
      }
    );
  }
);
Ie.displayName = "CommonInput";
const Qe = ve((e, t) => /* @__PURE__ */ o(
  Ie,
  {
    ref: t,
    ...e
  }
));
Qe.displayName = "Input";
const $o = ve(
  ({ label: e = "", description: t = "", rows: r = 4, ...i }, a) => /* @__PURE__ */ c(L, { children: [
    /* @__PURE__ */ c(
      L,
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          !!e && /* @__PURE__ */ o(je, { children: e }),
          !!t && /* @__PURE__ */ o(
            Z,
            {
              text: !i.isDisabled && t || "",
              placement: "left",
              children: /* @__PURE__ */ o(L, { children: /* @__PURE__ */ o(x, { icon: Fe }) })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ o(
      Ie,
      {
        ref: a,
        ...i,
        rows: r,
        isMultiline: !0
      }
    )
  ] })
);
$o.displayName = "Textarea";
const ui = F(N)(({ theme: e }) => ({
  boxShadow: Q.lg,
  marginTop: e.spacing(n.lg),
  marginBottom: e.spacing(n.lg),
  padding: e.spacing(n.xs, n.none),
  borderRadius: e.rounding(y.md),
  border: `1px solid ${e.palette.grey[200]}`
})), Lo = F(it)(({ theme: e }) => ({
  margin: e.spacing("1px", n.sm),
  // TODO: understand why this padding is not aligned to the DS spacings
  padding: "9px 10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: e.rounding(y.sm),
  minWidth: 120,
  gap: e.spacing(n.xs),
  color: e.palette.grey[700],
  "& span": {
    overflow: "hidden",
    textWrap: "nowrap",
    textOverflow: "ellipsis"
  },
  ...ie(e.palette.grey[500]),
  "& .MuiListItemButton-root": {
    ...ie("inherit")
  },
  "&:active, &:hover, &:focus-visible": {
    color: e.palette.grey[800],
    backgroundColor: `${e.palette.grey[50]} !important`
  },
  "&.Mui-disabled": {
    color: e.palette.grey[500],
    ...ie(e.palette.grey[400]),
    backgroundColor: "transparent",
    "& .MuiListItemButton-root": {
      ...ie("inherit")
    }
  },
  "&.Mui-selected": {
    backgroundColor: `${e.palette.grey[50]} !important`,
    "&:active, &:hover, &:focus-visible": {
      color: e.palette.grey[800],
      backgroundColor: `${e.palette.grey[50]} !important`
    }
  }
})), To = F(Le)(({ theme: e }) => ({
  "& .MuiTypography-root": {
    fontSize: "14px"
  },
  color: "inherit",
  fontWeight: e.typography.fontWeightMedium,
  lineHeight: "20px",
  display: "flex",
  flex: 1,
  overflow: "hidden"
})), Ze = F(Te)({
  "& svg": {
    width: 16,
    height: 16
  },
  minWidth: "24px !important",
  overflow: "hidden"
}), Ho = F(u)(({ theme: e }) => ({
  "& svg": {
    color: "inherit"
  },
  "& p": {
    width: 0,
    visibility: "hidden",
    display: "none"
  },
  maxWidth: "16px",
  padding: n.none,
  margin: n.none,
  width: 20,
  height: 24,
  display: "flex",
  alignItems: "center",
  backgroundColor: "transparent !important",
  marginRight: e.spacing(n.md)
})), De = ({ children: e }) => /* @__PURE__ */ o(Ho, { children: /* @__PURE__ */ o(Ze, { tabIndex: -1, children: e }) }), Oo = ({
  label: e,
  value: t,
  icon: r = void 0,
  isDisabled: i = !1,
  hasDivider: a = !1,
  iconColor: l = void 0,
  withCheckbox: s = !1,
  withRadio: d = !1,
  isSelected: g = !1,
  IconComponent: p = void 0,
  maxWidth: b = void 0,
  onClick: k = void 0,
  hasOptionCheckIcon: w = !1,
  tooltip: I = void 0,
  maxTooltipWidth: f = void 0
}) => {
  const z = re();
  return /* @__PURE__ */ c(_, { children: [
    /* @__PURE__ */ c(
      Lo,
      {
        disableRipple: !0,
        sx: { maxWidth: b },
        disabled: i,
        selected: g,
        role: "listitem",
        onClick: k,
        children: [
          /* @__PURE__ */ c(
            u,
            {
              display: "flex",
              alignItems: "center",
              width: "100%",
              minWidth: 0,
              children: [
                !!s && !d && /* @__PURE__ */ o(De, { children: /* @__PURE__ */ o(
                  qe,
                  {
                    label: "checkbox-ssdf",
                    checked: !!g,
                    size: "small"
                  }
                ) }),
                !!d && !s && /* @__PURE__ */ o(De, { children: /* @__PURE__ */ o(
                  Po,
                  {
                    checked: !!g,
                    size: "small",
                    label: "radio"
                  }
                ) }),
                !!(!d && !s && (!!r || !!p)) && /* @__PURE__ */ o(Ze, { children: p ?? (r && /* @__PURE__ */ o(
                  x,
                  {
                    icon: r,
                    style: { color: l ?? z.palette.grey[800] }
                  }
                )) }),
                /* @__PURE__ */ o(To, { children: e })
              ]
            }
          ),
          !!I && /* @__PURE__ */ o(
            Z,
            {
              title: I.title,
              text: I.text,
              extraContent: I.extraContent,
              placement: "right",
              maxBodyWidth: f,
              children: /* @__PURE__ */ o(
                x,
                {
                  icon: Fe,
                  style: { color: z.palette.grey[700] }
                }
              )
            }
          ),
          !!g && !!w && /* @__PURE__ */ o(
            x,
            {
              icon: qt,
              style: { color: z.palette.primary[600] }
            }
          )
        ]
      }
    ),
    !!a && /* @__PURE__ */ o(
      u,
      {
        my: n.xs,
        sx: {
          borderBottom: `1px solid ${z.palette.grey[200]}`
        }
      },
      `divider-${t}`
    )
  ] });
}, Vo = rt({
  isPlaylist: !1,
  playlist: [],
  wasPlayed: !1,
  setWasPlayed: () => {
  },
  isAutoplayOn: !0,
  toggleAutoplay: () => {
  },
  videoIndex: 0,
  nextVideo: () => {
  },
  prevVideo: () => {
  },
  goToVideo: () => {
  }
}), mi = () => nt(Vo), hi = (e = [], t = {}) => {
  const r = e.length > 0, [i, a] = j(!1), l = (m) => {
    a(m);
  }, s = new URLSearchParams(window.location.search).get("playlistAutoplay"), d = s ? !!JSON.parse(String(s).toLowerCase()) : void 0, g = typeof d < "u" ? d : !0, [p, b] = j(
    typeof t.isPlaylistAutoplayBehaviorOn < "u" ? t.isPlaylistAutoplayBehaviorOn : g
  ), k = () => {
    var m;
    (m = t.onAutoplayToggle) == null || m.call(t), b((v) => !v);
  }, w = new URLSearchParams(window.location.search).get("playlistVideoIndex"), I = w ? Number(w) : 0, [f, z] = j(I), W = () => {
    z((m) => {
      var D;
      const v = m > 0 ? m - 1 : e.length - 1;
      return (D = t.onPlaylistNav) == null || D.call(t, "prev", v), v;
    });
  }, h = () => {
    z((m) => {
      var D;
      const v = m < e.length - 1 ? m + 1 : 0;
      return (D = t.onPlaylistNav) == null || D.call(t, "next", v), v;
    });
  }, C = (m) => {
    var v;
    z(m), (v = t.onPlaylistNav) == null || v.call(t, m < f ? "prev" : "next", m);
  };
  return de(() => {
    if (!r)
      return;
    const m = new URLSearchParams(window.location.search);
    m.set("playlistVideoIndex", f.toString()), m.set("playlistAutoplay", p.toString());
    const v = new URL(window.location.href);
    v.search = new URLSearchParams(m).toString(), window.history.replaceState({}, document.title, v.toString());
  }, [r, f, p]), {
    isPlaylist: r,
    playlist: e,
    wasPlayed: i,
    setWasPlayed: l,
    isAutoplayOn: typeof t.isAutoplay < "u" && typeof t.onAutoplayToggle < "u" ? t.isAutoplay : p,
    toggleAutoplay: k,
    videoIndex: f,
    nextVideo: h,
    prevVideo: W,
    goToVideo: C
  };
}, We = ({
  onClick: e,
  size: t,
  shouldReset: r = !1
}) => /* @__PURE__ */ o(Je, { children: /* @__PURE__ */ o(
  Z,
  {
    title: r ? "Reset" : "Add Color",
    shouldHighlightChildIcon: !1,
    children: /* @__PURE__ */ o(
      u,
      {
        sx: {
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: n.xs
        },
        onClick: e,
        children: /* @__PURE__ */ o(
          u,
          {
            sx: {
              width: t,
              height: t,
              display: "flex",
              border: "1px solid",
              borderRadius: y.full,
              borderColor: "common.black",
              justifyContent: "center",
              alignItems: "center"
            },
            children: r ? /* @__PURE__ */ o(x, { icon: It }) : /* @__PURE__ */ o(
              x,
              {
                icon: St,
                size: "1x"
              }
            )
          }
        )
      }
    )
  }
) }), Ce = ({
  color: e,
  onClick: t,
  size: r
}) => /* @__PURE__ */ o(
  u,
  {
    onClick: t,
    "data-color": e,
    sx: (i) => ({
      width: r,
      height: r,
      backgroundColor: e,
      borderRadius: y.full,
      border: "1px solid",
      borderColor: "grey.200",
      margin: n.xs,
      cursor: "pointer",
      "&:hover": {
        boxShadow: i.shadows[2]
      }
    })
  }
), Se = F(u)(({ theme: e }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  backgroundColor: e.palette.common.white,
  gap: e.spacing(n.xl),
  width: "250px",
  paddingBottom: e.spacing(n.xl)
})), _o = F(Gt)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(n.xl),
  width: "100% !important",
  "& .react-colorful__saturation": {
    width: "100%",
    borderRadius: e.rounding(y.xxs),
    borderBottom: "none"
  },
  "& .react-colorful__alpha-pointer": {
    width: "16px",
    height: "16px"
  },
  "& .react-colorful__hue-pointer ": {
    width: "24px",
    height: "24px"
  },
  "& .react-colorful__saturation-pointer": {
    width: "16px",
    height: "16px",
    borderWidth: "2px"
  },
  "& .react-colorful__hue": {
    height: "24px",
    borderRadius: y.full,
    margin: e.spacing(0, n.xl)
  },
  "& .react-colorful__alpha": {
    height: "16px",
    borderRadius: y.full,
    margin: e.spacing(0, n.xl)
  }
})), jo = F(Qt)(({ theme: e }) => ({
  margin: e.spacing(0, n.xl),
  padding: e.spacing(n.sm),
  borderRadius: e.rounding(y.xxs),
  border: `1px solid ${e.palette.grey[300]}`
})), Ye = ({ color: e, onColorChange: t }) => {
  const r = Zt(e, 200);
  return /* @__PURE__ */ c(Se, { children: [
    /* @__PURE__ */ o(
      _o,
      {
        color: e,
        onChange: t
      }
    ),
    /* @__PURE__ */ o(
      jo,
      {
        color: r,
        onChange: t,
        prefixed: !0,
        alpha: !0
      }
    )
  ] });
}, ze = ({ onOpen: e, onClose: t } = {}) => {
  const [r, i] = j(null), a = R(
    (s) => {
      i(r ? null : s.currentTarget), r ? t == null || t() : e == null || e();
    },
    [r, t, e]
  ), l = R(() => {
    i(null), t == null || t();
  }, [t]);
  return de(
    // eslint-disable-next-line arrow-body-style
    () => () => {
      l();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), {
    anchorEl: r,
    setAnchorEl: i,
    isOpen: !!r,
    handleOpen: a,
    handleClose: l
  };
}, No = (e) => {
  const t = fe(!1), r = R(() => {
    t.current = !0;
  }, []);
  de(() => {
    let a = null;
    const l = () => {
      a = setTimeout(() => {
        t.current = !1;
      }, 200);
    };
    return window.addEventListener("mouseup", l), () => {
      window.removeEventListener("mouseup", l), a && clearTimeout(a);
    };
  }, []);
  const i = R(() => {
    t.current || e();
  }, [e]);
  return { handleMouseDown: r, handleClickAway: i };
}, Je = F(u)(({ theme: e }) => ({
  border: `1px solid ${e.palette.grey[200]}`
})), Uo = F(u)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(n.md),
  padding: e.spacing(n.md),
  backgroundColor: e.palette.common.white,
  maxWidth: "250px",
  width: "100%",
  flexWrap: "wrap"
})), qo = F(u)(({ theme: e }) => ({
  display: "flex",
  width: "100%",
  paddingTop: e.spacing(n.md),
  flexWrap: "wrap"
})), Xo = F(u)(() => ({
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
})), Go = F(u)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
  marginLeft: e.spacing(n.xl),
  marginRight: e.spacing(n.xl),
  gap: n.md
})), Qo = F(u)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  marginLeft: e.spacing(n.xl),
  marginRight: e.spacing(n.xl),
  gap: n.md
})), ae = 24, xi = ({
  color: e,
  presetColors: t,
  onColorChange: r,
  onSecondaryBtnClick: i = (f) => {
  },
  title: a = "",
  headerTitle: l,
  primaryBtnText: s = "Done",
  secondaryBtnText: d = "Cancel",
  children: g,
  shouldDisablePresetColor: p = !1,
  withReset: b = !1,
  withHeader: k = !1,
  onOpen: w,
  onClose: I
}) => {
  const [f, z] = j(e), [W, h] = Yt(), { anchorEl: C, handleOpen: m, handleClose: v, isOpen: D } = ze({
    onClose: () => {
      I == null || I(), h(!1);
    },
    onOpen: () => {
      w == null || w(), p && h(!0);
    }
  }), { handleClickAway: U, handleMouseDown: K } = No(v), V = ($) => {
    z($);
  }, q = R(() => {
    r(f), h(!1), p && v();
  }, [r, f, h, p, v]), ee = R(() => {
    i(f), h(!1), p && v();
  }, [i, f, h, p, v]), J = le(
    () => Array.from(
      new Set(
        t.flatMap(
          ($) => $.colors.length ? $.colors.flatMap(
            (X) => X && no(X) ? [X.toLowerCase()] : []
          ) : []
        )
      )
    ),
    [t]
  ), et = R(
    () => {
      var $;
      return /* @__PURE__ */ c(u, { children: [
        !!k && /* @__PURE__ */ c(
          u,
          {
            p: n.md,
            display: "flex",
            justifyContent: "space-between",
            children: [
              !!l && /* @__PURE__ */ o(
                E,
                {
                  variant: "text",
                  size: "sm",
                  fontWeight: "semibold",
                  children: l
                }
              ),
              /* @__PURE__ */ o(
                x,
                {
                  onClick: () => {
                    if (!p) {
                      h(!1);
                      return;
                    }
                    v();
                  },
                  icon: Oe,
                  style: {
                    color: ($ = Ne.grey) == null ? void 0 : $[800],
                    cursor: "pointer"
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c(Se, { children: [
          /* @__PURE__ */ o(
            Ye,
            {
              color: f,
              onColorChange: V
            }
          ),
          t.map(({ colors: X, title: Ae }) => /* @__PURE__ */ c(Qo, { children: [
            /* @__PURE__ */ o(
              E,
              {
                variant: "text",
                size: "sm",
                fontWeight: "semibold",
                children: Ae
              }
            ),
            /* @__PURE__ */ o(Xo, { children: X.map((ge) => /* @__PURE__ */ o(
              Ce,
              {
                color: ge,
                onClick: () => {
                  V(ge);
                },
                size: ae
              },
              String(ge)
            )) })
          ] }, Ae)),
          /* @__PURE__ */ o(
            ye,
            {
              flexItem: !0,
              sx: {
                mx: n.xl
              }
            }
          ),
          /* @__PURE__ */ c(Go, { children: [
            /* @__PURE__ */ o(
              oe,
              {
                onClick: q,
                variant: "contained",
                color: "primary",
                size: "small",
                children: s
              }
            ),
            /* @__PURE__ */ o(
              oe,
              {
                onClick: ee,
                variant: "outlined",
                color: "secondary",
                size: "small",
                children: d
              }
            )
          ] })
        ] })
      ] });
    },
    [
      q,
      ee,
      t,
      f,
      h,
      v,
      l,
      s,
      d,
      p,
      k
    ]
  ), tt = R(
    () => /* @__PURE__ */ c(Uo, { children: [
      /* @__PURE__ */ o(
        E,
        {
          variant: "text",
          size: "sm",
          fontWeight: "medium",
          children: a
        }
      ),
      /* @__PURE__ */ o(ye, { flexItem: !0 }),
      /* @__PURE__ */ c(qo, { children: [
        !!b && /* @__PURE__ */ o(
          We,
          {
            onClick: () => {
              r("transparent");
            },
            size: ae,
            shouldReset: !0
          }
        ),
        J.map(($, X) => /* @__PURE__ */ o(Je, { children: /* @__PURE__ */ o(
          Ce,
          {
            color: $,
            onClick: () => {
              r($);
            },
            size: ae
          }
        ) }, String($ + String(X)))),
        /* @__PURE__ */ o(
          We,
          {
            onClick: () => {
              h(!0);
            },
            size: ae
          }
        )
      ] })
    ] }),
    [J, r, a, h, b]
  );
  return /* @__PURE__ */ c(_, { children: [
    /* @__PURE__ */ o(u, { onClick: m, children: g }),
    /* @__PURE__ */ o(
      ne,
      {
        anchorEl: C,
        open: D,
        sx: { zIndex: 9999 },
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              boundary: "viewport"
              // Ensures Popper stays within the viewport
            }
          },
          {
            name: "flip",
            options: {
              fallbackPlacements: ["top", "bottom", "right", "left"]
              // Adjust placement if it overflows
            }
          }
        ],
        children: /* @__PURE__ */ o(ce, { onClickAway: U, children: /* @__PURE__ */ o(
          N,
          {
            elevation: 3,
            onMouseDown: K,
            "data-testid": "color-picker",
            children: W ? et() : tt()
          }
        ) })
      }
    )
  ] });
}, Zo = F(u)(() => ({
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
})), Yo = F(u)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
  marginLeft: e.spacing(n.xl),
  marginRight: e.spacing(n.xl),
  gap: n.md
})), Jo = F(u)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  marginLeft: e.spacing(n.xl),
  marginRight: e.spacing(n.xl),
  gap: n.md
})), Ko = 24, fi = ({
  color: e,
  presetColors: t,
  onColorChange: r,
  onCancel: i = () => {
  },
  onDone: a = () => {
  },
  headerTitle: l,
  children: s,
  withHeader: d = !1,
  onOpen: g,
  onClose: p,
  bounds: b = "window"
}) => {
  const k = fe(e), [w, I] = j({ x: 0, y: 0 }), f = fe(null), z = le(() => io(b), [b]), { anchorEl: W, handleOpen: h, handleClose: C, isOpen: m } = ze({
    onClose: p,
    onOpen: g
  }), v = R(() => {
    a(), C();
  }, [C, a]), D = R(() => {
    r(k.current), i(), C();
  }, [r, i, C]);
  Jt(f, D);
  const U = d, K = R(
    () => {
      var V;
      return /* @__PURE__ */ c(u, { ref: f, children: [
        !!d && /* @__PURE__ */ c(
          u,
          {
            p: n.md,
            display: "flex",
            justifyContent: "space-between",
            className: "header-drag-handle",
            sx: {
              cursor: U ? "move" : "default"
            },
            children: [
              !!l && /* @__PURE__ */ o(
                E,
                {
                  variant: "text",
                  size: "sm",
                  fontWeight: "semibold",
                  children: l
                }
              ),
              /* @__PURE__ */ o(
                x,
                {
                  onClick: D,
                  icon: Oe,
                  style: {
                    color: (V = Ne.grey) == null ? void 0 : V[800],
                    cursor: "pointer"
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c(Se, { children: [
          /* @__PURE__ */ o(
            Ye,
            {
              color: e,
              onColorChange: r
            }
          ),
          t.map(({ colors: q, title: ee }) => /* @__PURE__ */ c(Jo, { children: [
            /* @__PURE__ */ o(
              E,
              {
                variant: "text",
                size: "sm",
                fontWeight: "semibold",
                children: ee
              }
            ),
            /* @__PURE__ */ o(Zo, { children: q.map((J) => /* @__PURE__ */ o(
              Ce,
              {
                color: J,
                onClick: () => {
                  r(J);
                },
                size: Ko
              },
              String(J)
            )) })
          ] }, ee)),
          /* @__PURE__ */ o(
            ye,
            {
              flexItem: !0,
              sx: {
                mx: n.xl
              }
            }
          ),
          /* @__PURE__ */ c(Yo, { children: [
            /* @__PURE__ */ o(
              oe,
              {
                onClick: v,
                variant: "contained",
                color: "primary",
                size: "small",
                children: "Done"
              }
            ),
            /* @__PURE__ */ o(
              oe,
              {
                onClick: D,
                variant: "outlined",
                color: "secondary",
                size: "small",
                children: "Cancel"
              }
            )
          ] })
        ] })
      ] });
    },
    [d, U, l, e, r, t, v, D]
  );
  return /* @__PURE__ */ c(u, { children: [
    /* @__PURE__ */ o(u, { onClick: h, children: s }),
    U ? m && /* @__PURE__ */ o(
      Xt,
      {
        default: {
          x: 0,
          y: 0,
          width: "auto",
          height: "auto"
        },
        dragHandleClassName: "header-drag-handle",
        enableResizing: !1,
        bounds: z,
        onDragStop: (V, q) => {
          I({ x: q.x, y: q.y });
        },
        position: w,
        children: /* @__PURE__ */ o(
          N,
          {
            elevation: 3,
            "data-testid": "color-picker",
            children: K()
          }
        )
      }
    ) : /* @__PURE__ */ o(
      ne,
      {
        anchorEl: W,
        open: m,
        sx: { zIndex: 9999 },
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              boundary: "viewport"
            }
          },
          {
            name: "flip",
            options: {
              fallbackPlacements: ["top", "bottom", "right", "left"]
            }
          }
        ],
        children: /* @__PURE__ */ o(
          N,
          {
            elevation: 3,
            "data-testid": "color-picker",
            children: K()
          }
        )
      }
    )
  ] });
}, yi = "draggable-handle", er = 32, bi = O(N)(({ theme: e }) => ({
  position: "fixed",
  zIndex: 1e3,
  minWidth: 280,
  backgroundColor: e.palette.background.paper,
  borderRadius: e.rounding(y.xl),
  border: "1px solid",
  borderColor: e.palette.grey[300]
})), Ci = O(u, {
  shouldForwardProp: (e) => e !== "isDraggable"
})(({ isDraggable: e, theme: t }) => ({
  cursor: e ? "move" : "default",
  display: e ? "flex" : "none",
  alignItems: "center",
  "&:hover": {
    color: t.palette.primary[700]
  }
})), vi = O(u)({
  position: "absolute",
  top: 4,
  right: 4,
  zIndex: 2e3,
  display: "flex",
  alignItems: "center",
  gap: 4,
  height: er
});
O(u, {
  shouldForwardProp: (e) => e !== "theme"
})(({ theme: e }) => ({
  padding: e.spacing(n.xl, n["2xl"]),
  position: "absolute",
  top: 0,
  left: 0,
  height: 50
}));
const wi = O(u, {
  shouldForwardProp: (e) => e !== "theme"
})(({ theme: e }) => ({
  position: "relative",
  borderBottomLeftRadius: e.rounding(y.xl),
  borderBottomRightRadius: e.rounding(y.xl),
  display: "flex",
  flexDirection: "column"
})), Fi = O(u, {
  shouldForwardProp: (e) => e !== "theme"
})(({ theme: e }) => ({
  padding: e.spacing(n.none, n["2xl"]),
  marginBottom: 50
})), ki = O(u, {
  shouldForwardProp: (e) => e !== "theme"
})(({ theme: e }) => ({
  padding: e.spacing(n.lg, n["2xl"]),
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  gap: e.spacing(n.md),
  border: "1px solid",
  borderColor: e.palette.grey[200],
  backgroundColor: e.palette.grey[50],
  borderBottomLeftRadius: e.rounding(y.xl),
  borderBottomRightRadius: e.rounding(y.xl),
  position: "absolute",
  bottom: 0,
  left: 0,
  height: 50
})), tr = we(
  ({
    aiActions: e,
    getActionHandler: t,
    isActionEnabled: r,
    isCopyDisabled: i
  }) => /* @__PURE__ */ o(_, { children: e.map((a) => {
    const l = a.isAlwaysEnabled ?? r(a.id), s = a.id === "copy" && i || !l, d = a.tooltip;
    return /* @__PURE__ */ o(
      Z,
      {
        title: d,
        shouldHighlightChildIcon: !1,
        children: /* @__PURE__ */ o(u, { sx: { display: "inherit" }, children: /* @__PURE__ */ o(
          pe,
          {
            variant: "text",
            color: "secondary",
            label: a.id,
            onClick: t(a),
            size: "medium",
            "data-testid": a.id,
            disabled: s,
            disableBackground: !0,
            children: /* @__PURE__ */ o(x, { icon: a.icon })
          }
        ) })
      },
      a.id
    );
  }) })
);
tr.displayName = "ActionButtons";
const or = we(
  ({
    isLoading: e,
    text: t,
    error: r,
    isWriting: i,
    onWritingComplete: a
  }) => e ? /* @__PURE__ */ o(eo, { thickness: 4 }) : !t || r ? /* @__PURE__ */ c(
    P,
    {
      gap: n.lg,
      alignItems: "flex-start",
      justifyContent: "flex-start",
      direction: "row",
      children: [
        /* @__PURE__ */ o(u, { color: "error.600", children: /* @__PURE__ */ o(
          x,
          {
            icon: ht,
            size: "lg"
          }
        ) }),
        /* @__PURE__ */ o(
          E,
          {
            variant: "text",
            size: "sm",
            color: "grey.900",
            children: "No content available, please regenerate."
          }
        )
      ]
    }
  ) : i ? /* @__PURE__ */ o(
    to,
    {
      text: t,
      onComplete: a,
      variant: "text",
      size: "sm",
      loadingOptions: {
        thickness: 4
      }
    }
  ) : /* @__PURE__ */ c(
    E,
    {
      variant: "text",
      size: "sm",
      children: [
        /* @__PURE__ */ o(oo, { text: t }),
        /* @__PURE__ */ o("br", {}),
        /* @__PURE__ */ o("br", {})
      ]
    }
  )
);
or.displayName = "ResultContent";
const rr = O(at, {
  shouldForwardProp: (e) => e !== "theme"
})(({ theme: e }) => ({
  padding: e.spacing(n.xl)
})), nr = O(lt, {
  shouldForwardProp: (e) => e !== "theme"
})(({ theme: e }) => ({
  padding: e.spacing(n.sm),
  borderRadius: e.rounding(y.md),
  "&:hover": {
    backgroundColor: e.palette.grey[100]
  }
})), ir = F(N)(({ theme: e }) => ({
  minWidth: 280,
  backgroundColor: e.palette.background.paper,
  borderRadius: e.rounding(y.xl),
  border: "1px solid",
  borderColor: e.palette.grey[300],
  boxShadow: e.shadows[5]
})), ar = ({
  item: { label: e, icon: t, onClick: r, subOptions: i, ...a },
  level: l = 0,
  onSubMenuOpen: s = void 0,
  onSubMenuClose: d = void 0
}) => {
  const { anchorEl: g, isOpen: p, handleOpen: b, handleClose: k } = ze(), w = (f) => {
    i != null && i.length ? (b(f), s == null || s()) : r == null || r();
  };
  return Kt(() => {
    k(), d == null || d();
  }), /* @__PURE__ */ c(_, { children: [
    /* @__PURE__ */ c(
      nr,
      {
        onClick: w,
        role: "menuitem",
        "aria-disabled": "true",
        ...a,
        children: [
          !!t && /* @__PURE__ */ o(Te, { sx: { minWidth: 30 }, children: /* @__PURE__ */ o(x, { icon: t }) }),
          /* @__PURE__ */ o(
            Le,
            {
              primary: /* @__PURE__ */ o(
                E,
                {
                  variant: "text",
                  size: "sm",
                  fontWeight: "medium",
                  color: "grey.700",
                  children: e
                }
              )
            }
          ),
          !!(i != null && i.length) && /* @__PURE__ */ o(
            x,
            {
              icon: zt,
              color: "grey.800"
            }
          )
        ]
      }
    ),
    !!(i != null && i.length) && /* @__PURE__ */ o(
      ne,
      {
        open: p,
        anchorEl: g,
        placement: "right",
        sx: { zIndex: 1001 },
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 20]
            }
          }
        ],
        children: /* @__PURE__ */ o(ce, { onClickAway: k, children: /* @__PURE__ */ o(ir, { children: /* @__PURE__ */ o(rr, { children: i.map((f) => /* @__PURE__ */ o(
          ar,
          {
            item: f,
            level: l + 1,
            onSubMenuOpen: s,
            onSubMenuClose: d
          },
          f.label
        )) }) }) })
      }
    )
  ] });
}, lr = ({
  values: e,
  onEdit: t,
  onDelete: r,
  getValueLabel: i,
  shouldWrapWithSpacing: a = !1,
  badgeMaxWidth: l = void 0,
  badgesColorPalette: s
}) => e.map((d) => {
  const g = i ? i(d) : typeof d == "string" ? d : "", p = s == null ? void 0 : s[g], b = p ? "filled" : "outlined";
  return /* @__PURE__ */ o(
    u,
    {
      sx: {
        ...a && {
          pt: n.md,
          pl: n.md
        },
        maxWidth: l
      },
      children: /* @__PURE__ */ o(
        zo,
        {
          label: g,
          variant: b,
          color: p,
          size: "small",
          ...t && {
            onClick: () => {
              t(d);
            }
          },
          ...r && {
            onDelete: () => {
              r(d);
            }
          }
        }
      )
    },
    g
  );
}), sr = F(N)(({ theme: e }) => ({
  boxShadow: Q.lg,
  marginTop: e.spacing(n.xs),
  padding: e.spacing(n.md),
  borderRadius: e.rounding(y.md),
  border: `1px solid ${e.palette.grey[200]}`
})), Pe = 500, Ii = ({
  anchorElement: e,
  onClose: t,
  canOverflowParent: r = !1,
  ...i
}) => /* @__PURE__ */ o(
  ne,
  {
    anchorEl: e,
    open: !0,
    transition: !0,
    disablePortal: !r,
    sx: (a) => ({ zIndex: r ? a.zIndex.modal + 1 : 2 }),
    children: ({ TransitionProps: a }) => /* @__PURE__ */ o(He, { ...a, children: /* @__PURE__ */ o(sr, { children: /* @__PURE__ */ o(ce, { onClickAway: t, children: /* @__PURE__ */ o(
      P,
      {
        direction: "row",
        sx: {
          mt: -n.md,
          ml: -n.md,
          flexWrap: "wrap",
          width: "100%",
          maxWidth: Pe
        },
        children: /* @__PURE__ */ o(
          lr,
          {
            ...i,
            shouldWrapWithSpacing: !0,
            badgeMaxWidth: Pe
          }
        )
      }
    ) }) }) })
  }
), dr = (e) => {
  const t = e.getIsPinned();
  return t ? {
    clipPath: "inset(0 -100px 0 0)",
    left: t === "left" ? `${e.getStart("left")}px` : void 0,
    position: "sticky"
  } : {};
}, Re = {
  headerCellSeparator: "Separator",
  isHorizontalScroll: "IsHorizontalScroll",
  pinnedColumn: "LeftPinned",
  lastPinnedColumn: "LastLeftPinned"
}, cr = (e) => {
  const t = e.getIsPinned(), r = t === "left" && e.getIsLastColumn("left");
  return t ? {
    className: `${Re.pinnedColumn} ${r ? Re.lastPinnedColumn : ""}`
  } : {};
}, Ke = (e) => !!e.isPlaceholderRow, pr = ({
  getValueLabel: e,
  value: t
}) => e ? e(t) : typeof t == "string" ? t : "", Me = [
  S.error,
  S.indigo,
  S.pink,
  S.primary,
  S.purple,
  S.rose,
  S.success,
  S.warning
], gr = (e) => {
  const t = 2166136261n, r = 16777619n, a = Array.from(e).reduce((l, s) => (l ^ BigInt(s.charCodeAt(0))) * r, t) & BigInt(4294967295);
  return Number(a);
}, Si = ({
  getValueLabel: e,
  possibleValues: t
}) => {
  const r = Me.length, i = t.map((a) => {
    const l = pr({
      value: a,
      getValueLabel: e
    }), d = gr(l) % r;
    return [l, Me[d]];
  });
  return Object.fromEntries(i);
}, ur = ({ cell: e }) => {
  const [t, r] = j(!1), i = Ke(e.row.original);
  return /* @__PURE__ */ c(
    st,
    {
      onMouseEnter: () => {
        r(!0);
      },
      onMouseLeave: () => {
        r(!1);
      },
      sx: {
        width: `var(--column-${e.column.id}-size)`,
        ...dr(e.column)
      },
      ...cr(e.column),
      children: [
        !!i && /* @__PURE__ */ o(
          u,
          {
            sx: {
              position: "relative",
              height: "100%",
              overflow: "hidden"
            },
            children: /* @__PURE__ */ o(
              u,
              {
                sx: {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  left: 0,
                  height: "1px",
                  backgroundColor: "grey.200"
                }
              }
            )
          }
        ),
        ro(e.column.columnDef.cell, { ...e.getContext(), isHovered: t })
      ]
    }
  );
}, mr = ({ tableController: e }) => /* @__PURE__ */ o(dt, { children: e.getRowModel().rows.map((t) => {
  const r = Ke(t.original);
  return /* @__PURE__ */ o(
    ct,
    {
      sx: {
        ...r && {
          height: "100%",
          "& .MuiTableCell-root": {
            padding: "0px !important",
            border: "none !important",
            backgroundColor: "white !important"
          }
        }
      },
      children: t.getVisibleCells().map((i) => /* @__PURE__ */ o(
        ur,
        {
          cell: i
        },
        i.id
      ))
    },
    t.id
  );
}) }), zi = we(mr, (e, t) => t.tableController.getState().columnSizingInfo.isResizingColumn ? e.tableController.options.data === t.tableController.options.data : !1), hr = F(N)(({ theme: e }) => ({
  boxShadow: Q.lg,
  marginTop: e.spacing(n.xs),
  paddingTop: e.spacing(n.xl),
  borderRadius: e.rounding(y.md),
  border: `1px solid ${e.palette.grey[200]}`,
  width: 280,
  overflowY: "hidden"
})), Ai = ({
  anchorElement: e,
  onClose: t,
  selectedOptions: r,
  onChange: i,
  options: a,
  search: l = void 0,
  setSearch: s = void 0,
  isClientFiltering: d = !0,
  isLoading: g = !1,
  shouldDisplayNoOptionsLabel: p = !0
}) => {
  const b = re(), [k, w] = j("");
  de(() => {
    l && w(l);
  }, [l]);
  const I = le(() => d ? pt()(a, { inputValue: k, getOptionLabel: (m) => m.label }) : a, [d, a, k]), f = le(() => r.map((h) => h.value), [r]), z = (h) => {
    const C = f.includes(h.value) ? r.filter((m) => m.value !== h.value) : [...r, h];
    i(C);
  }, W = R((h) => {
    h == null || h.focus();
  }, []);
  return /* @__PURE__ */ o(
    ne,
    {
      anchorEl: e,
      open: !0,
      transition: !0,
      disablePortal: !0,
      sx: { zIndex: 1 },
      placement: "bottom-start",
      children: ({ TransitionProps: h }) => /* @__PURE__ */ o(He, { ...h, children: /* @__PURE__ */ o(hr, { children: /* @__PURE__ */ o(ce, { onClickAway: t, children: /* @__PURE__ */ c(P, { spacing: n.lg, children: [
        /* @__PURE__ */ o(
          P,
          {
            px: n.xl,
            sx: {
              "& .MuiInputBase-root": {
                py: "9px",
                px: "13px",
                ...b.typography.body1
              }
            },
            children: /* @__PURE__ */ o(
              Qe,
              {
                ref: W,
                value: k,
                onChange: (C) => {
                  const m = C.target.value;
                  w(m), s == null || s(m);
                },
                placeholder: "Search",
                startIcon: /* @__PURE__ */ o(x, { icon: ut }),
                endAdornment: !!g && /* @__PURE__ */ o(
                  _e,
                  {
                    size: 20,
                    label: "Search"
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ c(
          gt,
          {
            disablePadding: !0,
            role: "list",
            sx: {
              overflowY: "auto",
              maxHeight: "240px",
              pb: n.xs
            },
            children: [
              !I.length && !!p && /* @__PURE__ */ o(P, { sx: { px: n.xl, py: n.xs }, children: /* @__PURE__ */ o(
                E,
                {
                  size: "sm",
                  variant: "text",
                  color: "grey.500",
                  children: "No options"
                }
              ) }),
              I.map((C) => {
                const m = f.includes(C.value);
                return /* @__PURE__ */ o(
                  Oo,
                  {
                    value: String(C.value),
                    label: /* @__PURE__ */ o(
                      E,
                      {
                        size: "sm",
                        fontWeight: "medium",
                        variant: "text",
                        children: C.label
                      }
                    ),
                    onClick: () => {
                      z(C);
                    },
                    withCheckbox: !0,
                    isSelected: m
                  },
                  C.value
                );
              })
            ]
          }
        )
      ] }) }) }) })
    }
  );
};
export {
  ko as $,
  Do as A,
  Co as B,
  qe as C,
  Oo as D,
  fi as E,
  or as F,
  ki as G,
  tr as H,
  x as I,
  hi as J,
  Vo as K,
  Ii as L,
  Y as M,
  lr as N,
  Ke as O,
  xi as P,
  Si as Q,
  Po as R,
  ci as S,
  $o as T,
  Re as U,
  dr as V,
  cr as W,
  zi as X,
  he as Y,
  ie as Z,
  Fo as _,
  zo as a,
  li as a0,
  ii as a1,
  ai as a2,
  si as a3,
  ni as a4,
  mi as a5,
  di as b,
  oe as c,
  pe as d,
  gi as e,
  Qe as f,
  Je as g,
  Ai as h,
  Ue as i,
  ar as j,
  pi as k,
  fo as l,
  yo as m,
  No as n,
  Ye as o,
  yi as p,
  bi as q,
  vi as r,
  Ci as s,
  So as t,
  ze as u,
  Ne as v,
  bo as w,
  ui as x,
  wi as y,
  Fi as z
};
